import servicesDataJson from "../../data/hostingAndCloudServices.json";

export default function Section2() {
  const servicesData = servicesDataJson;

  return (
    <div className="Section2 py-[35px] bg-[#F5F5F5]">
      <div className="container-1280 section2-container text-[#535353] w-full px-[15px] mx-auto md:w-[750px] lg:w-[970px] xl:w-[100%]">
        <h1 className="text-[#da2128] font-bold text-[24px] md:text-[34px] text-center leading-[40px] my-[0.67em]">
          Hosting & Cloud Services
        </h1>

        <p className="mb-5 text-center leading-[23px] font-open">
          Cloud hosting is the ability for a site to be stored on various
          servers. It will help you ensure the right resources are pulled from
          various places, enabling the ability to be a scalable, reliable and
          flexible option for hosting. This ensures your site traffic
          experiences are stable from dips or hikes. Choosing us as a web
          hosting provider will enable you to ensure your infrastructure is
          scalable and cost-effective based on the resources you want to use,
          speed and performance that prioritizes uptime and loading speeds, and
          security that is not reliant on an internal server locally. We as
          providers will help you present an infrastructure and services that
          look at.
        </p>

        <div className="flex flex-col justify-between flex-nowrap md:flex-row md:flex-wrap font-open">
          {servicesData.map(({ imgUrl, title, text }, index) => {
            return (
                <div key={index} className="md:w-[46%] lg:w-[49%]">
                    <div className="text-[22px] my-[10px] font-bold text-[#cd2122] leading-[28px] capitalize flex w-full items-center"><img src={imgUrl} className="mr-[10px]"></img>{title}</div>
                    <p className="mb-[20px]">{text}</p>
                </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
